import { render, staticRenderFns } from "./CrudPrizesList.vue?vue&type=template&id=5c788e04&"
import script from "./CrudPrizesList.vue?vue&type=script&lang=js&"
export * from "./CrudPrizesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports